export default class {
  rectanglesAreCrossed(aX, aY, bX, bY, pX, pY, qX, qY) {
    if (aX > bX) {
      let t = aX
      aX = bX
      bX = t
    }
    if (aY > bY) {
      let t = aY
      aY = bY
      bY = t
    }
    if (pX > qX) {
      let t = pX
      pX = qX
      qX = t
    }
    if (pY > qY) {
      let t = pY
      pY = qY
      qY = t
    }
    return this.sortedRectanglesAreCrossed(aX, aY, bX, bY, pX, pY, qX, qY)
  }

  sortedRectanglesAreCrossed(aX, aY, bX, bY, pX, pY, qX, qY) {
    return (
      this.sortedSegmentsAreCrossed(aX, bX, pX, qX) && this.sortedSegmentsAreCrossed(aY, bY, pY, qY)
    )
  }

  sortedSegmentsAreCrossed(a, b, p, q) {
    return (
      this.segmentCoversPoint(a, b, p) ||
      this.segmentCoversPoint(a, b, q) ||
      this.segmentCoversPoint(p, q, a) ||
      this.segmentCoversPoint(p, q, b)
    )
  }

  segmentCoversPoint(a, b, p) {
    return a <= p && p <= b
  }
}
